import { render } from "./shopifyProblem.vue?vue&type=template&id=2a2b217e&scoped=true"
import script from "./shopifyProblem.vue?vue&type=script&lang=js"
export * from "./shopifyProblem.vue?vue&type=script&lang=js"

import "./shopifyProblem.vue?vue&type=style&index=0&id=2a2b217e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a2b217e"]])

export default __exports__